import {Component, HostListener, Input, OnInit} from '@angular/core';
import {BrowserService} from '../../../shared/services/browser.service';
import {VideoFullScreenStateUpdateAction} from '../../../shared/stores/root-store/actions/timeline.action';
import {FullScreenStateEnum} from '../../../../enums/full-screen-state.enum';
import {Store} from '@ngrx/store';
import VideoState from '../../../shared/stores/root-store/video.state';
import {selectFullScreenStateFromState} from '../../../shared/stores/root-store/selectors/video.selector';

@Component({
    selector: 'eocm-full-screen',
    templateUrl: './full-screen.component.html',
    styleUrls: ['./full-screen.component.scss']
})

export class FullScreenComponent implements OnInit {

    public isFullScreen = false;
    public openEventFired = false;

    private docElement;
    private doc;

    private readonly OPEN_FULLSCREEN_MSG = 'open-fullscreen';
    private readonly CLOSE_FULLSCREEN_MSG = 'close-fullscreen';

    @Input() isMobileDevice;

    public constructor(private browser: BrowserService,
        private store: Store<{ video: VideoState }>) {
    }

    @HostListener('document:webkitfullscreenchange', ['$event'])
    @HostListener('document:mozfullscreenchange', ['$event'])
    @HostListener('document:fullscreenchange', ['$event'])
    @HostListener('document:MSFullscreenChange', ['$event'])
    onFullScreenChange(): void {
        if (this.isFullScreen && this.openEventFired) {
            this.openEventFired = false;
            this.store.dispatch(VideoFullScreenStateUpdateAction({
                fullScreenState: FullScreenStateEnum.ClosedByKeyboard
            }));
        }
        if (!this.openEventFired) {
            this.openEventFired = true;
        }
    }

    public ngOnInit(): void {
        this.docElement = document.documentElement;
        this.doc = window.document;
        this.initializeFullScreenState();
    }

    public fullScreenClick(): void {
        if (!this.isFullScreen) {
            this.invokeFullScreen();
        } else {
            this.closeFullScreen();
        }
        this.setFullScreenState();
    }

    private initializeFullScreenState(): void {
        this.store.select(selectFullScreenStateFromState).subscribe((fullScreenState) => {
            this.isFullScreen = fullScreenState === FullScreenStateEnum.Active;
            this.openEventFired = false;
            this.initFakeFullScreenForIos();
        });
    }

    private initFakeFullScreenForIos(): void {
        if (this.browser.isAppleMobileDevice() || this.browser.isAppleDeviceWithIos13plus()) {
            window.parent.postMessage(
                this.isFullScreen
                    ? this.OPEN_FULLSCREEN_MSG
                    : this.CLOSE_FULLSCREEN_MSG,
                '*');
        }
    }

    private setFullScreenState(): void {
        this.store.dispatch(VideoFullScreenStateUpdateAction({
            fullScreenState: this.isFullScreen ?
                FullScreenStateEnum.ClosedByButtonClick :
                FullScreenStateEnum.Active
        }));
    }

    private invokeFullScreen(): void {
        if (this.browser.isAppleMobileDevice() || this.browser.isAppleDeviceWithIos13plus()) {
            this.invokeFullScreenOnIos();
        } else if (this.browser.isSafari()) {
            this.docElement.webkitRequestFullScreen();
        } else {
            this.docElement.requestFullscreen();
        }
    }

    private closeFullScreen(): void {
        if (this.browser.isAppleMobileDevice()) {
            this.closeFullScreenOnIos();
        } else if (this.browser.isSafari()) {
            this.doc.webkitExitFullscreen();
        } else {
            document.exitFullscreen();
        }
    }

    private invokeFullScreenOnIos(): void {
        window.parent.postMessage(this.OPEN_FULLSCREEN_MSG, '*');
        window.addEventListener('orientationchange', () => {
            window.parent.postMessage(this.OPEN_FULLSCREEN_MSG, '*');
        });
    }

    private closeFullScreenOnIos(): void {
        window.parent.postMessage(this.CLOSE_FULLSCREEN_MSG, '*');
        window.removeEventListener('orientationchange', () => {})
    }
}
